module.exports = __webpack_public_path__ + "static/media/Straw_Medium.67326601.webp";